import * as actions from "Actions";
import * as api from "Api";

export const fetchAnnexeList = organizationUen => {
  return (dispatch, getState) => {
    const {
      auth: { currentOrganization, portail },
      annexes: {
        annexesList: { filter, paginationPage, pageSize }
      },
      balanceSheet: { organization }
    } = getState();

    let uen = organizationUen;
    if (!uen) {
      uen = organization.uen;
    }

    return dispatch(
      actions.getAnnexeList(
        api.getAnnexeList(
          uen,
          filter,
          paginationPage,
          pageSize,
          currentOrganization,
          portail
        )
      )
    );
  };
};

export const fetchAnnexeTemporaryLink = (id, filePath) => {
  return (dispatch, getState) => {
    return dispatch(
      actions.getAnnexeTemporaryLink(api.getAnnexeTemporaryLink(id, filePath))
    );
  };
};

export const deleteAnnexe = id => (dispatch, getState) => {
  const {
    auth: { currentOrganization }
  } = getState();
  return dispatch(
    actions.deleteAnnexe(
      api.deleteAnnexe({
        uen: currentOrganization.uen,
        id: id
      })
    )
  );
};

export const setMainAnnexe = (id, uen) => (dispatch, getState) => {
  return dispatch(
    actions.setMainAnnexe(
      api.setMainAnnexe({
        uen: uen,
        id: id
      })
    )
  );
};

export const toggleHiddenAnnexe = (id, uen) => (dispatch, getState) => {
  return dispatch(
    actions.toggleHiddenAnnexe(
      api.toggleHiddenAnnexe({
        uen: uen,
        id: id
      })
    )
  );
};

export const toggleCertifiedAnnexe = (id, uen) => (dispatch, getState) => {
  return dispatch(
    actions.toggleCertifiedAnnexe(
      api.toggleCertifiedAnnexe({
        uen: uen,
        id: id
      })
    )
  );
};

export const fetchBalanceSheetAttachments = organizationUen => {
  return (dispatch, getState) => {
    const {
      auth: { currentOrganization },
      balanceSheet: { organization }
    } = getState();

    let uen = organizationUen;
    if (!uen) {
      uen = organization.uen;
    }

    return dispatch(
      actions.getBalanceSheetAttachments(
        api.getBalanceSheetAttachments({
          clientUen: uen,
          fiduciaryUen: currentOrganization.uen
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/annexe.js